module.exports = __webpack_public_path__ + "static/media/video-letgo-zh.6fe3cee0.vtt";